import { Plug, MessageSquareReply, History, BarChart3 } from "lucide-react";
import { Reveal, Chapter } from "../components/Reveal";

const CARDS = [
  {
    icon: Plug,
    title: "Connect",
    text: "We connect the channels you already use — website forms, phone, WhatsApp, email, and your existing CRM or booking system — without replacing any of them.",
  },
  {
    icon: MessageSquareReply,
    title: "Respond",
    text: "Every new enquiry is met with a fast, structured response and routed appropriately, so first contact is never left to chance.",
  },
  {
    icon: History,
    title: "Recover",
    text: "People who don't book immediately — and older leads that went quiet — are followed up in a structured way instead of going cold.",
  },
  {
    icon: BarChart3,
    title: "Measure",
    text: "You get visibility into enquiry volume, response times, bookings and recovered opportunities, all in one place.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="scroll-mt-24 border-t border-ink/10 py-24 md:py-32"
    >
      <div className="mx-auto max-w-6xl px-6">
        <Reveal>
          <Chapter number="03" label="How It Works" />
        </Reveal>
        <Reveal delay={60}>
          <h2 className="max-w-3xl font-display text-3xl font-medium leading-tight tracking-tight text-ink sm:text-4xl lg:text-5xl">
            A simple process, built around your existing setup
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {CARDS.map((card, i) => (
            <Reveal key={card.title} delay={i * 120} className="h-full">
              <div
                data-testid={`how-it-works-card-${i}`}
                className="flex h-full flex-col rounded-2xl border border-ink/10 bg-white p-7"
              >
                <div className="flex items-center justify-between">
                  <span className="font-display text-4xl font-medium text-teal/30">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="flex h-11 w-11 items-center justify-center rounded-full bg-teal-soft">
                    <card.icon size={20} className="text-teal" strokeWidth={1.8} />
                  </div>
                </div>
                <h3 className="mt-6 font-display text-xl font-medium text-ink">{card.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-ink/65">{card.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={200}>
          <p
            data-testid="how-it-works-closing-line"
            className="mx-auto mt-16 max-w-3xl text-center text-base italic leading-relaxed text-ink/70 md:text-lg"
          >
            Leadtochair is designed to support your team, not replace them.
            Judgement calls, clinical questions and patient relationships stay
            with your practice — the system handles the structure and
            consistency around them.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
